import React, { memo, forwardRef } from "react";
const SvgAlpha = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M11.585 21.928c.783.496 1.688.744 2.711.744.64 0 1.216-.08 1.729-.24.512-.176.96-.408 1.344-.696.384-.304.704-.648.96-1.032h.168c.175.736.456 1.248.84 1.536.4.288.896.432 1.488.432a2.89 2.89 0 00.215-.006c.46-.015 1.185-.138 1.7-.748a.855.855 0 00-.087-1.18.795.795 0 00-1.146.076.44.44 0 01-.19.122.942.942 0 01-.564-.28c-.192-.208-.288-.56-.288-1.056v-9.118a.914.914 0 00-1.815-.16l-.177.998h-.096a4.116 4.116 0 00-1.008-1.032 4.165 4.165 0 00-1.32-.696 4.926 4.926 0 00-1.656-.264c-1.649 0-2.953.576-3.913 1.728-.944 1.152-1.416 2.816-1.416 4.992 0 1.456.224 2.68.672 3.672.448.976 1.064 1.712 1.848 2.208zm5.255-1.512c-.527.336-1.232.504-2.111.504-1.136 0-2-.408-2.592-1.224-.593-.816-.889-2.024-.889-3.624 0-1.616.28-2.848.84-3.696.577-.864 1.449-1.296 2.617-1.296 1.376 0 2.327.424 2.856 1.272.544.848.816 2.072.816 3.672v.144c0 1.088-.12 1.984-.36 2.688-.24.704-.633 1.224-1.177 1.56z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgAlpha.displayName = "SvgAlpha";
const MemoForwardRef = memo(SvgAlpha);
export default MemoForwardRef;
